export default "__VITE_ASSET__7PRVzLoS__"